module.exports = __webpack_public_path__ + "img/x.6c84ad7b.svg";